module.exports = __webpack_public_path__ + "media/marqeta_replacement/house-ce0168f9.png";